import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';

export default class ComparableApiService {
  static BASE_URL = `/${Enums.ComparableApiPathEnum.COMPARABLE}/${Enums.ServerlessApiPathEnum.V1}`;

  static getComparable(body) {
    return ServerlessApiService.post(this.BASE_URL, body);
  }
}
